<template>
  <div class="section-new">
    <Row :gutter="16">
      <i-col span="12">
        <Form ref="newForm" :model="model"
          :rules="modelValidate"
          label-position="left"
          :label-width="140">
          <FormItem label="名称" prop="name">
            <Input v-model="model.name" placeholder="输入名称" />
          </FormItem>
          <FormItem label="是否显示标题" prop="showTitle">
            <i-switch v-model="model.showTitle"></i-switch>
          </FormItem>
          <FormItem label="标题" prop="title">
            <Input v-model="model.title" placeholder="输入名称" />
          </FormItem>
          <FormItem label="是否为附件" prop="isAttachment">
            <i-switch v-model="model.isAttachment"></i-switch>
          </FormItem>
          <FormItem label="是否为企业自评项" prop="isSelfAppraise">
            <i-switch v-model="model.isSelfAppraise"></i-switch>
          </FormItem>
          <FormItem label="总分" prop="totalScore">
            <InputNumber v-model="model.totalScore" placeholder="输入总分" />
          </FormItem>
          <FormItem label="评分表达式" prop="scoreFormula">
            <Input v-model="model.scoreFormula" placeholder="输入评分表达式" />
            <span><a href="https://mathjs.org/docs/expressions/syntax.html" target="_blank">https://mathjs.org/docs/expressions/syntax.html</a></span>
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from '../../api/Api.js'
export default {
  name: 'question-new',
  props: {
  },
  data () {
    return {
      loading: false,
      model: {
        name: null,
        title: null,
        showTitle: true,
        isAttachment: false,
        isSelfAppraise: true,
        scoreFormula: null,
        totalScore: 0
      },
      modelValidate: {
        name: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请填写标题', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          await Api.Appraisal.addAppraisalSection(this.model)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('新增成功!')
              this.model= {
                name: null,
                title: null,
                showTitle: true,
                isAttachment: false,
                isSelfAppraise: true,
                scoreFormula: null,
                totalScore: 0
              }
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    }
  }
}
</script>

<style lang="less">
</style>
